import React from 'react';

const VisaIcon = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 32 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5333 10.3333H11.6L13.4667 0.666667H16.4L14.5333 10.3333Z"
        fill="#1434CB"
      />
      <path
        d="M24.2667 0.933333C23.6667 0.733333 22.6667 0.466667 21.4667 0.466667C18.8 0.466667 16.9333 1.8 16.9333 3.66667C16.9333 5.06667 18.2667 5.8 19.3333 6.26667C20.4 6.73333 20.8 7.06667 20.8 7.46667C20.8 8.13333 19.9333 8.4 19.1333 8.4C18 8.4 17.4 8.2 16.4667 7.86667L16.0667 7.66667L15.6667 10.0667C16.4 10.3333 17.6667 10.6 19 10.6C21.8667 10.6 23.6667 9.26667 23.6667 7.33333C23.6667 6.13333 22.8667 5.2 21.2667 4.53333C20.2667 4.06667 19.6667 3.73333 19.6667 3.26667C19.6667 2.86667 20.0667 2.46667 21.0667 2.46667C21.9333 2.46667 22.5333 2.6 23.0667 2.86667L23.3333 2.93333L23.7333 0.666667L24.2667 0.933333Z"
        fill="#1434CB"
      />
      <path
        d="M27.7333 0.666667H29.9333L32 10.3333H29.2667C29.2667 10.3333 29 9.26667 28.9333 8.93333H25.2L24.4667 10.3333H21.4L26.2 1.13333C26.5333 0.533333 27.0667 0.666667 27.7333 0.666667ZM26.4667 6.93333H28.4C28.2667 6.26667 27.6667 4.13333 27.6667 4.13333L27.2 5.73333C27.2 5.73333 26.6667 6.73333 26.4667 6.93333Z"
        fill="#1434CB"
      />
      <path
        d="M9.53333 0.666667L6.8 7.33333L6.53333 6.13333L5.66667 1.33333C5.53333 0.8 5.13333 0.666667 4.66667 0.666667H0.133333L0 0.866667C1 1.13333 1.93333 1.53333 2.53333 1.93333L4.93333 10.3333H7.93333L12.4667 0.666667H9.53333Z"
        fill="#1434CB"
      />
    </svg>
  );
};

export default VisaIcon; 